var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { OutsourceSettleManageService } from "~/services/domain-service/outsource-settle-manage.service";
import { PageService } from "~/utils/page.service";
import NumberRange from "~/components/common/number-range.vue";
import { CityService } from "~/utils/city.service";
import { SortService } from "~/utils/sort.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import { State } from "vuex-class";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var SellteManageIndex = /** @class */ (function (_super) {
    __extends(SellteManageIndex, _super);
    function SellteManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        _this.proinviceList = []; // 省
        _this.cityList = []; //市
        // form 查询表单参数
        _this.queryModel = {
            outBatch: "",
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            localAddress: "",
            currentCollector: "",
            overduePeriod: "",
            turnSource: "",
            FollowupBack: "",
            productCategory: "",
            productName: "",
            area: "",
            followupBack: "",
            outAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overdueDays: {
                max: "",
                min: ""
            },
            followInTime: [],
            outsName: "",
            labelName: []
        };
        _this.dataList = [];
        return _this;
    }
    SellteManageIndex.prototype.mounted = function () {
        this.refreshData();
        this.getProvinces();
    };
    //获取省数据
    SellteManageIndex.prototype.getProvinces = function () {
        this.proinviceList = CityService.getCityData({ level: 1 });
    };
    //获取市
    SellteManageIndex.prototype.getCitys = function (provinceId) {
        if (this.queryModel.cityCode) {
            this.queryModel.cityCode = "";
        }
        this.cityList = this.$city.getCityData({ level: 1, id: provinceId }); // 城市列表
    };
    /**
     * 查询列表
     */
    SellteManageIndex.prototype.refreshData = function () {
        var _this = this;
        this.OutsourceSettleManageService.getCaseSettlePoolPageList(this.queryModel, this.pageService, this.sortService).subscribe(function (data) {
            _this.dataList = data;
        });
    };
    /**
     * 进入查看执行页
     */
    SellteManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Outsource_settle,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 重置numberRange
     */
    SellteManageIndex.prototype.follFeedback = function () {
        this.queryModel.outAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.proinviceCode = "";
        this.queryModel.cityCode = "";
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    __decorate([
        Dependencies(OutsourceSettleManageService)
    ], SellteManageIndex.prototype, "OutsourceSettleManageService", void 0);
    __decorate([
        Dependencies(PageService)
    ], SellteManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], SellteManageIndex.prototype, "sortService", void 0);
    __decorate([
        State
    ], SellteManageIndex.prototype, "outSourceList", void 0);
    SellteManageIndex = __decorate([
        Auth(1005),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange
            }
        })
    ], SellteManageIndex);
    return SellteManageIndex;
}(Vue));
export default SellteManageIndex;
